import Keepa from 'assets/html-pwa/Keepa/logo192.png';
import Entekhab from 'assets/html-pwa/Entekhab/192-type2.png';
import Tantak from 'assets/html-pwa/Darsad/splash-icon.png';
import Sabalend from 'assets/html-pwa/Sabalend/splash-icon.png';
import Refahyar from 'assets/html-pwa/Refahyar/splash-icon.png';
import fara from 'assets/html-pwa/Fara/fara192x192.png';
import hamtaland from 'assets/html-pwa/Hamtaland/hamtaland - 192-min.png';
import rayansaipa from 'assets/html-pwa/Rayansaipa/180-180 (1).png';
import ghestane from 'assets/html-pwa/Ghestane/size176.jpg';
import tisa from 'assets/html-pwa/Tisa/176.png';
import saana from 'assets/html-pwa/Saana/176.png';
import shopp from 'assets/html-pwa/Shopp/176.png';
import arbaeen from 'assets/html-pwa/Arbaeen/176.png';
import danesh from 'assets/html-pwa/Danesh/danesh 176 176.png';
import hastesh from 'assets/html-pwa/Hastesh/176-176-min.png';
import armanpay from 'assets/html-pwa/Armanpay/176.png';
import lendavidpay from 'assets/html-pwa/Lendavid/176-176.png';
import flyToday from 'assets/html-pwa/Flytoday/176.png';
import calko from 'assets/html-pwa/Calko/Calko176.png';
import can from 'assets/html-pwa/Can/176x176.png';
import karma from 'assets/html-pwa/Karma/176.png';

import iosPWASplash from 'ios-pwa-splash';

const usePwaSplash = () => {
	const projectName = process.env.REACT_APP_PROJECT_NAME;

	const returnColorSplash = {
		keepa: {
			color: '#35306f',
			icon: Keepa,
		},
		'tantak': {
			color: '#e43024',
			icon: Tantak,
		},
		entekhab: {
			color: '#00A361',
			icon: Entekhab,
		},
		sabalend: {
			color: '#106239',
			icon: Sabalend,
		},
		'refahyar': {
			color: '#106239',
			icon: Refahyar,
		},
		fara: {
			color: '#ffffff',
			icon: fara,
		},
		hamtaland: {
			color: '#ffffff',
			icon: hamtaland,
		},
		rayansaipa: {
			color: '#ffff',
			icon: rayansaipa,
		},
		ghestane: {
			color: '#ffff',
			icon: ghestane,
		},
		tisa: {
			color: '#ffff',
			icon: tisa,
		},
		saana: {
			color: '#ffff',
			icon: saana,
		},
		shopp: {
			color: '#ffff',
			icon: shopp,
		},
		arbaeen: {
			color: '#ffff',
			icon: arbaeen,
		},
		danesh: {
			color: '#ffff',
			icon: danesh,
		},
		karma: {
			color: '#ffff',
			icon: karma,
		},
		hastesh: {
			color: '#ffff',
			icon: hastesh,
		},
		armanpay: {
			color: '#ffff',
			icon: armanpay,
		},
		calko: {
			color: '#ffff',
			icon: calko,
		},
		lendavid: {
			color: '#ffff',
			icon: lendavidpay,
		},
		'flytoday': {
			color: '#ffff',
			icon: flyToday,
		},
		can: {
			color: '#ffff',
			icon: can,
		},
		demo: {
			color: '',
			icon: '',
		},
	};

	iosPWASplash(returnColorSplash[projectName]?.icon, returnColorSplash[projectName]?.color);

	return null;
};

export default usePwaSplash;
